import React from "react"
import styled from "styled-components"
import { setColor, setFlex, setRem, media, setLetterSpacing } from "../../style"

import { FaCheck } from "react-icons/fa"
import { FormattedMessage } from "gatsby-plugin-intl"

const VacationDeals = () => {
  return (
    <Container>
      <div className="left">
        <h3>
          <FormattedMessage id="home.vacationDeals.mexico" />{" "}
        </h3>
        <div className="line"></div>
        <h2><FormattedMessage id="home.vacationDeals.vacationDeals" /> </h2>
      </div>
      <div className="right">
        <ul>
          <li>
            <FaCheck className="icon" /> &nbsp;<FormattedMessage id="home.vacationDeals.mazatlan" />
          </li>
          <li>
            <FaCheck className="icon" /> &nbsp;Cozumel
          </li>
          <li>
            <FaCheck className="icon" /> &nbsp;<FormattedMessage id="home.vacationDeals.mayanRiviera" />
          </li>
        </ul>
      </div>
    </Container>
  )
}

export default VacationDeals

const Container = styled.div`
  color: ${setColor.mainWhite};
  font-weight: 700;
  ${setFlex};
  flex-wrap: wrap;
  text-transform: uppercase;

  .left {
    line-height: normal;
    letter-spacing: normal;
    text-align: center;

    h3 {
      font-size: ${setRem(72)};
      ${media.tablet`
        font-size: ${setRem(140)};
      `}
    }

    .line {
      border: 2px solid ${setColor.secondaryColor};
      margin-top: -${setRem(8)};
      margin-bottom: ${setRem(20)};
      ${media.tablet`
        margin-top: -${setRem(20)};
      `}
    }

    h2 {
      font-size: ${setRem(28)};
      margin-bottom: ${setRem(20)};
      ${media.tablet`
      ${setLetterSpacing(0)};
          font-size: ${setRem(61)};
      `}
    }
  }
  .right {
    font-size: ${setRem(24)};
    margin-left: ${setRem(35)};
    ${media.tablet`
        font-size: ${setRem(46)};
        
    `}
    ul {
      list-style: none;
    }
    .icon {
      color: ${setColor.primaryColor};
      font-size: ${setRem(18)};
      ${media.tablet`
            font-size: ${setRem(46)};
        `}
    }
  }
`
